import { useRef, useState, useEffect, useMemo } from 'react'
import { uniq, assign } from 'lodash-es'
import AMapLoader from '@amap/amap-jsapi-loader'

const DEFAULTCENTER = [116.364288, 39.919495] // 西城中心
const DEFAULTZOOM = 13
/*
 * 默认 normal
 * 幻影黑 dark
 * 月光银 light
 * 远山黛 whitesmoke
 * 草色青 fresh
 * 雅士灰 grey
 * 涂鸦 graffiti
 * 马卡龙 macaron
 * 靛青蓝 blue
 * 极夜蓝 darkblue
 * 酱籽 wine
 */
const DEFAULTTHEME = 'normal'

// // 存储地图构造函数
// let AMap = null
// // 存储多个地图实例
// let amap = {}
// // 卫星图层实例
// let satelliteLayer = null

const defaultAmapPlugins = [
  'AMap.Geocoder',
  // 'AMap.MouseTool',
  // 'AMap.PolyEditor',
  // 'AMap.AutoComplete',
  // 'AMap.PlaceSearch',
  'AMap.CustomLayer',
  // 'AMap.MarkerClusterer',
  // 'AMap.GeoJSON',
]

// const renderLayers = (AMapCls, aMapInstance, layers) => {
//   layers.map((layer) => {
//     const render = this.layerRenders('cluster')
//     render()
//   })
// }

let AMapClsCache = null

const useAmap = (mapId, opts = {}, afterInit) => {
  const AMap = useRef()
  const aMapInstance = useRef()
  const [inited, setInited] = useState(false)
  const apis = useRef({})

  const { plugins, amapKey } = opts

  const amapPlugins = useMemo(() => {
    let result = [...defaultAmapPlugins]
    if (plugins) {
      plugins.forEach((plugin) => {
        result = uniq(result.concat(plugin.amapPlugins))
      })
    }
    return result
  }, [plugins])

  useEffect(() => {
    const init = (AMapCls) => {
      AMapClsCache = AMapCls
      AMap.current = AMapCls
      aMapInstance.current = new AMapCls.Map(mapId, {
        center: opts.center || DEFAULTCENTER,
        zoom: opts.zoom || DEFAULTZOOM,
        zooms: opts.zooms,
        mapStyle: `amap://styles/${opts.mapStyle || DEFAULTTHEME}`,
        layers: opts.getLayers ? opts.getLayers(AMapCls) : [],
        viewMode: '3D',
      })
      plugins.forEach((plugin) => {
        const papis = plugin.setApis(AMap.current, aMapInstance.current)
        apis.current = assign(apis.current, papis)
      })
      if (afterInit) {
        afterInit({
          getAmap: () => aMapInstance.current,
          getApis: () => apis.current,
        })
      }
      // callbacks.current = Object.assign(callbacks.current, plugin.setCallbacks())
      // apis.current = Object.assign(
      //   callbacks,
      //   plugin.setApis(AMap.current, amapInstance.current)
      // )
      // plugin.setApis(AMap.current, amapInstance.current)
      // console.log('[2]', setApis)
      setInited(true)
    }

    // if () {
    // 这里其实可以判断 AMap 的存在性, 免得重复加载
    // }
    //
    AMapLoader.load({
      key: amapKey,
      version: '2.0',
      plugins: [...amapPlugins, 'AMap.ToolBar'],
      Loca: {
        version: '2.0.0',
      },
    })
      .then(init)
      .catch((err) => {
        // 不知道为什么某些情况下会抛出一个undefined的err，这里catch住重新init一遍
        if (!err) {
          init(AMapClsCache)
        }
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    return () => {
      AMapClsCache = null
      aMapInstance.current?.destroy()
    }
  }, [])

  return {
    AMap,
    inited,
    getAmap: () => aMapInstance.current,
    getApis: () => apis.current,
    addControl: (v) => {
      aMapInstance.current.addControl(v)
    },
  }
}

export default useAmap
